import { render, staticRenderFns } from "./VirtualScreenSource.vue?vue&type=template&id=2baa010b&scoped=true"
import script from "./VirtualScreenSource.vue?vue&type=script&lang=ts"
export * from "./VirtualScreenSource.vue?vue&type=script&lang=ts"
import style0 from "./VirtualScreenSource.vue?vue&type=style&index=0&id=2baa010b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa010b",
  null
  
)

export default component.exports